module.exports = __webpack_public_path__ + "img/female-elderly-head.4e6fbeb2.svg";